import { createHandlerChainRunner, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { updateCart } from "@insite/client-framework/Services/CartService";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { Draft } from "immer";
import cloneDeep from "lodash/cloneDeep"

type Parameter = { shipComplete: string, shouldUpdateCart?: boolean } & HasOnSuccess;
type HandlerType = Handler<Parameter>;

export const DispatchSetShipComplete: HandlerType = (props: {
    readonly parameter: Readonly<Parameter>;
    dispatch: any;
}) => {
    props.dispatch({
        type: "xCheckoutState/SetShipComplete",
        shipComplete: props.parameter.shipComplete,
    });
};

export const UpdateCartSavingShipComplete: HandlerType = async props => {
    if(!props.parameter.shouldUpdateCart) {
        return false;
    }
    const { value: cart } = getCurrentCartState(props.getState());
    
    if (!cart) {
        throw new Error("The cart is not loaded. Try reloading the page.");
    }

    const cartClone = cloneDeep(cart) as Draft<typeof cart>;
    cartClone.properties.customerShipComplete = props.parameter.shipComplete;
    await updateCart({ cart: cartClone });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [DispatchSetShipComplete, UpdateCartSavingShipComplete, ExecuteOnSuccessCallback];

const setShipComplete = createHandlerChainRunner(chain, "SetShipComplete");
export default setShipComplete;
